import { IsoDate } from '@softline/core';

export const CERTIFICATE_DOCUMENT_TYPES = [
  'OFFER',
  'SALES_ORDER',
  'WORK_ORDER',
  'DELIVERY_NOTE',
  'DRAFT',
  'PURCHASE_ORDER',
  'PURCHASE_DELIVERY_NOTE',
  'INCOMING_PRODUCTS',
] as const;
export type CertificateDocumentType = (typeof CERTIFICATE_DOCUMENT_TYPES)[number];

export const CERTIFICATE_DOCUMENT_TYPE_LABELS: Record<CertificateDocumentType, string> = {
  OFFER: 'Offert',
  SALES_ORDER: 'Auftrag',
  WORK_ORDER: 'Arbeitsschein',
  DELIVERY_NOTE: 'Lieferschein',
  DRAFT: 'Entwurf / Verkauf',
  PURCHASE_ORDER: 'Bestellung',
  PURCHASE_DELIVERY_NOTE: 'Warenzugang (Einkauf)',
  INCOMING_PRODUCTS: 'Warenübernahme (Einkauf)',
};

export interface CertificateType {
  id: number;
  code: string;
  name?: string;
  description?: string;
}

export interface CertificateArea {
  id: number;
  code: string;
  name?: string;
  description?: string;
}

export interface Certificate {
  id: number;
  number: string;
  registrationNumber: IsoDate;
  validFrom: IsoDate;
  validTo?: IsoDate;
  inspectionDate?: string;
  type: CertificateType;
  area: CertificateArea;
}

export interface DocumentCertificate {
  certificate: Certificate;
  percentage: number;
}

export interface DocumentCertificateRequest {
  documentType: CertificateDocumentType;
  documentId: number;
  certificate: Certificate;
  percentage: number;
}
